<app-layer-config-collapsible-category
  description="Road Hazards"
  storageKey="rc-road-hazards"
  [collapsedDefault]="false"
>
  <ng-container *hasPermissionAny="Layers.RoadSegment.permissions">
    <app-layer-config-item
      *ngVar="getMetricFromMap(metrics.RoadSegment_RoadCondition) as metric"
      [description]="metric.displayName"
      [isSelected]="selectedRoadMetric === metric.key"
      [key]="metric.key"
      [icon]="metric.icon"
      (clicked)="setMetric($event)"
    ></app-layer-config-item>
  </ng-container>
  <!--Remove once migration is complete-->
  <ng-container *hasPermissionAny="[Permissions.RCS_RoadSegments_All_Read]">
    <app-layer-config-item
      *ngVar="getMetricFromMap(metrics.RoadSegment_TractionLoss) as metric"
      [description]="metric.displayName"
      [isSelected]="selectedRoadMetric === metric.key"
      [key]="metric.key"
      [icon]="metric.icon"
      (clicked)="setMetric($event)"
    ></app-layer-config-item>
  </ng-container>
</app-layer-config-collapsible-category>
